/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { useLocation } from "react-router";
import { NavLink, useHistory } from "react-router-dom";
import { checkIsActive, toAbsoluteUrl } from "../../../../_helpers";
import { RoleChecker } from "../../../../../app/RoleChecker";
import BusinessIcon from "@material-ui/icons/Business";
import AssignmentIcon from "@material-ui/icons/Assignment";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import SVG from "react-inlinesvg";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import StorageIcon from "@material-ui/icons/Storage";

export function SAAsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }

  const query = useQuery();
  const simpzStatus = query.get("simpz_status");
  const isNearlyExpired = query.get("is_nearly_expired");

  const history = useHistory();

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Menu List */}
        {/* begin::section */}
        <li className="menu-section ">
          <h4 className="menu-text">Daftar Menu</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>
        {/* end:: section */}

        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/admin/organization",
            false
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/admin/organization">
            <span className="svg-icon menu-icon">
              <BusinessIcon />
            </span>
            <span className="menu-text">Lembaga</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {RoleChecker("Read", "organization") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/admin/organization/register",
                    false
                  )}`}
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    // to="/admin/organization?simpz_status=ACTIVE"
                    to="/admin/organization/register"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Daftar</span>
                  </NavLink>
                </li>
              )}
              {RoleChecker("Approval", "organization") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/admin/organization/SUBMIT",
                    false
                  )}`}
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/admin/organization/SUBMIT"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Menunggu Approval</span>
                  </NavLink>
                </li>
              )}
              {RoleChecker("Read", "organization") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/admin/organization/is_nearly_expired",
                    false
                  )}`}
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/admin/organization/is_nearly_expired"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Mendekati Expire</span>
                  </NavLink>
                </li>
              )}
              {RoleChecker("Read", "organization_feature") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/admin/organization/feature",
                    true,
                    false
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/admin/organization/feature"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Fitur Lembaga</span>
                    {/* <i className="menu-arrow" /> */}
                  </NavLink>
                </li>
              )}
            </ul>
          </div>
        </li>
        {/* DI HIDE DULU */}
        {/* {RoleChecker("Read", "organization") && (
          <>
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/admin/_organization-file",
                false
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink
                className="menu-link menu-toggle"
                to="/admin/_organization-file"
              >
                <span className="svg-icon menu-icon">
                  <BusinessIcon />
                </span>
                <span className="menu-text">Kelengkapan Dokumen</span>
              </NavLink>
            </li>
          </>
        )} */}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/admin/report",
            false
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink
            className="menu-link menu-toggle"
            to="/admin/report/organization"
          >
            <span className="svg-icon menu-icon">
              <AssignmentIcon />
            </span>
            <span className="menu-text">Laporan</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {RoleChecker("Read", "organization_report") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/admin/report/organization",
                    false
                  )}`}
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/admin/report/organization"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Laporan Organisasi</span>
                  </NavLink>
                </li>
              )}
              {RoleChecker("Read", "organization_consolidation") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/admin/report/consolidation",
                    false
                  )}`}
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/admin/report/consolidation"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Laporan Konsolidasi</span>
                  </NavLink>
                </li>
              )}
              {RoleChecker("Read", "organization_consolidation") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/admin/report/recapitulation",
                    false
                  )}`}
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/admin/report/recapitulation"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Laporan Rekapitulasi</span>
                  </NavLink>
                </li>
              )}
              {RoleChecker("Export", "organization_consolidation") && (
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/admin/report/export/consolidation",
                    false
                  )}`}
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/admin/report/export/consolidation"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Export Konsolidasi</span>
                  </NavLink>
                </li>
              )}
            </ul>
          </div>
        </li>
        {RoleChecker("Read", "library") && (
          <>
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/admin/library",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/admin/library">
                <span className="svg-icon menu-icon">
                  <LibraryBooksIcon />
                </span>
                <span className="menu-text">Library</span>
              </NavLink>
            </li>
          </>
        )}
        {RoleChecker("Read", "notification_organization") && (
          <>
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/admin/notification",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink
                className="menu-link menu-toggle"
                to="/admin/notification"
              >
                <span className="svg-icon menu-icon">
                  <NotificationsActiveIcon />
                </span>
                <span className="menu-text">Notifikasi Organisasi</span>
              </NavLink>
            </li>
          </>
        )}
        {RoleChecker("Read", "notification_template") && (
          <>
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/admin/template-notification",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink
                className="menu-link menu-toggle"
                to="/admin/template-notification"
              >
                <span className="svg-icon menu-icon">
                  <AllInboxIcon />
                </span>
                <span className="menu-text">Template Notifikasi</span>
              </NavLink>
            </li>
          </>
        )}
        <>
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/admin/master-data",
              false
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/admin/master-data">
              <span className="svg-icon menu-icon">
                <StorageIcon />
              </span>
              <span className="menu-text">Master Data</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {RoleChecker("Read", "master_data_classification") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/admin/master-data/classification-org",
                      false
                    )}`}
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/admin/master-data/classification-org"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Klasifikasi</span>
                    </NavLink>
                  </li>
                )}
                {RoleChecker("Read", "master_data_regional") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/admin/master-data/regional",
                      false
                    )}`}
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/admin/master-data/regional"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Regional</span>
                    </NavLink>
                  </li>
                )}
                {RoleChecker("Read", "master_data_category") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/admin/master-data/category",
                      false
                    )}`}
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/admin/master-data/category"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Kategori</span>
                    </NavLink>
                  </li>
                )}
                {RoleChecker("Read", "master_data_access_role") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/admin/master-data/access-role",
                      false
                    )}`}
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/admin/master-data/access-role"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Akses Role</span>
                    </NavLink>
                  </li>
                )}
                {RoleChecker("Read", "master_data_access_role") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/admin/master-data/log-login",
                      false
                    )}`}
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/admin/master-data/log-login"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Log Login</span>
                    </NavLink>
                  </li>
                )}
                {RoleChecker("Read", "master_data_user") && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/admin/master-data/user",
                      false
                    )}`}
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/admin/master-data/user"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">User</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        </>
      </ul>
    </>
  );
}
